const routes = [
  {
    url: /\/Auth\/trusthub-validate-object-access\?entityLegacyId=\d+&objectName=\w+/,
    method: 'Get',
    reply: function (request) {
      return [200, { success: true, message: '' }]
    }
  },
  {
    url: /\/order\/finalization-by-responsibility\?LegacyEntityId=\d+&OrderCode=.*/,
    method: 'Get',
    reply: function (request) {
      return [
        200,
        {
          status: [
            { id: 0, name: 'Aprovar' },
            { id: 1, name: 'Cancelar' }
          ]
        }
      ]
    }
  },
  {
    url: /\/order\/list.*/,
    method: 'Get',
    reply: function (request) {
      const baseOrder = {
        orderCode: '1234',
        cpfCnpj: '47244086857',
        email: 'pedro.leal@clear.sale',
        value: 123.12,
        status: '1',
        score: '12',
        orderDate: Date.now(),
        registerDate: Date.now(),
        externalLink: 'https://google.com.br',
        isPrioritizable: true,
        isReanalyzable: true
      }

      const data = {
        byOrderCode: baseOrder,
        byCpfCnpj: {
          orders: Array.from({ length: 10 }, () => baseOrder),
          page: 0,
          pageQuantity: 10,
          count: 10
        }
      }

      return [200, { ...data }]
    }
  }
]

export default routes
